<template>
  <div class="eng-detail-page">
    <el-container style="width: 100%;height: 100%;padding: 0">
      <el-header class="detailHeader" height="60px" v-show="!getFullscreenStatus">
        <el-row style="height:60px;overflow: hidden">
          <el-col :lg="6" :md="3" :xl="6" class="hidden-sm-and-down">
            <el-breadcrumb class="detailBread fl" separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/engineering' }">面板</el-breadcrumb-item>
              <el-breadcrumb-item>编辑</el-breadcrumb-item>
              <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <!--          显示工具栏中的组件信息-->
          <el-col :lg="13" :md="15" :sm="18" :xl="13" :xs="18" class="workOption">
            <ul class="clearfix">
              <li
                :key="index"
                @click="(event) => handleClickComponent(event,item)"
                @dragstart="(event) => handleDragComponent(event, item)"
                class="drag-component"
                draggable="true"
                v-for="(item,index) in workOption">
                <Icon :type="item.icons"/>
                <i>{{item.text}}</i>
              </li>
              <li
                  draggable="true">
                <el-popover
                    placement="bottom"
                    width="450"
                    trigger="hover">
                  <el-tabs v-model="customComponentGroupIndex">
                    <el-tab-pane class="workOption">
                      <span slot="label" style="font-weight:bold;font-size: 14px">
                        <i class="el-icon-receiving"
                           style="font-size: 18px;text-align: center;display: block"></i>
                        数值操作
                      </span>
                      <ul class="clearfix">
                        <li
                          @click="(event) => handleClickComponent(event,item)"
                          @dragstart="(event) => handleDragComponent(event, item)"
                          class="drag-component"
                          style="float: left;padding: 10px;"
                          draggable="true"
                          v-for="(item,index) in numericOption"
                          :key="index">
                        <Icon :type="item.icons" style="font-size: 24px;text-align: center;display: block;cursor: pointer;"/>
                        <i style="cursor: pointer;">{{item.text}}</i>
                      </li>
                    </ul>
                    </el-tab-pane>
                    <el-tab-pane class="workOption">
                      <span slot="label" style="font-weight:bold;font-size: 14px">
                        <i class="el-icon-open"
                           style="font-size: 18px;text-align: center;display: block"></i>
                        布尔操作
                      </span>
                      <ul class="clearfix">
                        <li
                            @click="(event) => handleClickComponent(event,item)"
                            @dragstart="(event) => handleDragComponent(event, item)"
                            class="drag-component"
                            style="float: left;padding: 10px;"
                            draggable="true"
                            v-for="(item,index) in booleanOption"
                            :key="index">
                          <Icon :type="item.icons" style="font-size: 24px;text-align: center;display: block;cursor: pointer;"/>
                          <i style="cursor: pointer;">{{item.text}}</i>
                        </li>
                      </ul>
                    </el-tab-pane>
                    <el-tab-pane>
                      <span slot="label" style="font-weight:bold;font-size: 14px">
                        <i class="el-icon-notebook-2"
                           style="font-size: 18px;text-align: center;display: block"></i>
                        下拉
                      </span>
                      <ul class="clearfix">
                        <li
                            @click="(event) => handleClickComponent(event,item)"
                            @dragstart="(event) => handleDragComponent(event, item)"
                            class="drag-component"
                            style="float: left;padding: 10px;"
                            draggable="true"
                            v-for="(item,index) in pullDownOption"
                            :key="index">
                          <Icon :type="item.icons" style="font-size: 24px;text-align: center;display: block;cursor: pointer;"/>
                          <i style="cursor: pointer;">{{item.text}}</i>
                        </li>
                      </ul>
                    </el-tab-pane>
                    <el-tab-pane>
                      <span slot="label" style="font-weight:bold;font-size: 14px">
                        <i class="el-icon-data-analysis"
                           style="font-size: 18px;text-align: center;display: block"></i>
                        图表
                      </span>
                      <ul class="clearfix">
                        <li
                            @click="(event) => handleClickComponent(event,item)"
                            @dragstart="(event) => handleDragComponent(event, item)"
                            class="drag-component"
                            style="float: left;padding: 10px;"
                            draggable="true"
                            v-for="(item,index) in chartOption"
                            :key="index">
                          <Icon :type="item.icons" style="font-size: 24px;text-align: center;display: block;cursor: pointer;"/>
                          <i style="cursor: pointer;">{{item.text}}</i>
                        </li>
                      </ul>
                    </el-tab-pane>
                    <el-tab-pane>
                      <span slot="label" style="font-weight:bold;font-size: 14px">
                        <i class="el-icon-stopwatch"
                           style="font-size: 18px;text-align: center;display: block"></i>
                        仪表盘
                      </span>
                      <ul class="clearfix">
                        <li
                            @click="(event) => handleClickComponent(event,item)"
                            @dragstart="(event) => handleDragComponent(event, item)"
                            class="drag-component"
                            style="float: left;padding: 10px;"
                            draggable="true"
                            v-for="(item,index) in dashboardOption"
                            :key="index">
                          <Icon :type="item.icons" style="font-size: 24px;text-align: center;display: block;cursor: pointer;"/>
                          <i style="cursor: pointer;">{{item.text}}</i>
                        </li>
                      </ul>
                    </el-tab-pane>
                  </el-tabs>
                  <div slot="reference">
                    <Icon type="ios-apps-outline"/>
                    <i>自定义组件</i>
                  </div>
                </el-popover>
              </li>
            </ul>
          </el-col>
          <!-- 保存0/撤销1/重做2相关 -->
          <el-col :lg="3" :md="4" :sm="4" :xl="3" :xs="4" class="workOption">
            <ul class="clearfix">
              <li :key="index" @click="operateRelate(index)" style="color: #fff"
                  v-for="(item,index) in workOptiothree">
                <Icon :type="item.icons"/>
                <i>{{item.text}}</i>
              </li>
            </ul>
          </el-col>
          <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2" class="workOption">
            <ul class="clearfix">
              <li :key="index"
                  @click="exitProject"
                  style="color: #fff"
                  v-for="(item,index) in workOptioform">
                <Icon :type="item.icons"/>
                <i>{{item.text}}</i>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-header>
      <el-main style="width: 100%;padding: 0">
        <div @mousedown="containerMouseDown"
             @mouseleave="canDrag=false"
             @mousemove="containerMousemove"
             @mouseup="containerMouseup"
             @touchend="containerMouseup"
             @touchmove="containerMousemove"
             @touchstart="containerMouseDown"
             class="detail-main">
          <el-aside :width="leftWidth+'px'">
            <left-aside @minimize="minimize"/>
          </el-aside>
          <!-- 组件模块部分 -->
          <el-main :class="{'components-part':true,'components-part-fullscreen':getFullscreenStatus}">
            <div class="panel-title">
              <div :style="panelTitleStyle" class="title">
                <i @click="leftWidth=400" class="el-icon-d-arrow-right"
                   style="font-size: 25px;font-weight: bold;margin-right: 10px"
                   v-show="leftWidth<100">
                </i>
                <span style="font-size: 18px;font-weight: bold" v-show="!getFullscreenStatus">面板</span>
              </div>
              <div class="data-require-btn" v-show="!getFullscreenStatus">
                  <el-button type="text" style="padding: 0px" v-show="cptsEditVisible" @click="clearCpt">取消选中</el-button>
                  <el-button type="text" style="padding: 0px" v-show="cptsEditVisible" @click="deleteSelectedCpts">删除</el-button>
                  <el-button type="text" style="padding: 0px;margin-right: 20px"
                             v-show="cptsEditVisible" @click="cptSettingVisible=true">设置</el-button>
                <el-button-group>
                  <el-button :disabled="projectStatus" @click="startToGetPanelData" icon="el-icon-check" size="small"
                             type="primary"
                  >
                    开始
                  </el-button>
                  <el-button :disabled="!projectStatus" @click="stopToGetPanelData" icon="el-icon-close" size="small"
                             type="primary">
                    结束
                  </el-button>
                </el-button-group>
              </div>
              <div class="fullscreen-btn">
                <i @click="switchFullscreen" class="el-icon-full-screen"
                   style="font-size: 25px;font-weight: bold;margin-left: 20px"></i>
              </div>
            </div>
            <el-dialog
                :append-to-body="true"
                :visible.sync="cptSettingVisible"
                title="设置"
                width="30%">
              <el-row>
                <el-col :span="8">
                  <span style="font-size: 16px;display: block">字体大小</span>
                  <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
                </el-col>
                <el-col :span="8">
                  <span style="font-size: 16px;display: block">颜色</span>
                  <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
                </el-col>
                <el-col :span="8">
                  <span style="font-size: 16px;display: block">预览</span>
                  <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
                </el-col>
              </el-row>
              <span class="dialog-footer" slot="footer">
                <el-button @click="cptSettingVisible = false">取 消</el-button>
                <el-button @click="cptSettingVisible = false,setSelectedCptStyle()" type="primary">确 定</el-button>
              </span>
            </el-dialog>
            <div :class="{'mouseDrag':isDrag}"
                 @dragover="allowComponentDrop"
                 @drop="dragTocomponentsContainer"
                 class="components-container"
                 style="position: relative">
              <!-- 显示组件的grid布局 -->
              <grid-layout
                  :col-num="colNum"
                  :is-draggable="true"
                  :is-mirrored="false"
                  :is-resizable="true"
                  :layout.sync="getPanelData_cg"
                  :margin="[0, 0]"
                  :row-height="5"
                  :use-css-transforms="true"
                  :vertical-compact="false"
                  :prevent-collision="true"
                  style="width:100%;height:100%">
<!--                col-num:48 row-height:30-->
                <el-dialog
                  :append-to-body="true"
                  :visible.sync="passwordVisible"
                  @close="password=''"
                  title="用户认证"
                  width="50%">
                  <p style="font-size:15px">请输入密码以启用标定输入组件:</p>
                  <el-input placeholder="请输入密码" show-password style="width: 50%;margin-top:8px"
                            v-model="password"></el-input>
                  <span class="dialog-footer" slot="footer">
                    <el-button @click="passwordVisible = false">取 消</el-button>
                    <el-button @click="add" type="primary">确 定</el-button>
                  </span>
                </el-dialog>
                <grid-item
                  :class="{'hide-border':(item.ctype===COMPONENT_TYPE.UDS||item.ctype===COMPONENT_TYPE.SWITCHER
                  ||item.ctype === COMPONENT_TYPE.DASHBOARD)||item.ctype ===COMPONENT_TYPE.VIDEO
                  ||item.ctype ===COMPONENT_TYPE.NUMERICINDICATOR ||item.ctype ===COMPONENT_TYPE.SLIDER
                  ||item.ctype ===COMPONENT_TYPE.NUMERICCONTROL ||item.ctype ===COMPONENT_TYPE.TRIGGER}"
                    :h="item.h"
                    :i="item.i"
                    :key="item.key"
                    :w="item.w"
                    :x="item.x"
                    :y="item.y"
                    :minH="item.ctype ===COMPONENT_TYPE.NUMERICCONTROL || item.ctype ===COMPONENT_TYPE.NUMERICINDICATOR ? 8 : 1 "
                    :maxH="item.ctype ===COMPONENT_TYPE.NUMERICCONTROL || item.ctype ===COMPONENT_TYPE.NUMERICINDICATOR ? 18 : Infinity "
                    dragIgnoreFrom="a"
                    @moved="gridMove"
                    @move="moveEvent"
                    @resized="gridResize"
                    style="border:1px solid rgba(51, 137, 232, 0.75);z-index: 9"
                    v-for="item in getPanelData_cg">
<!--                  @resized="gridResized"-->
                  <!-- 示波器 -->
                  <div class="cmp-style" v-if="item.ctype===COMPONENT_TYPE.Oscillogram">
                    <signal-cmp :itemIndex="item.key"
                                :signal-item="item"
                                :startStatus="startStatus"
                                @save-cpm="operateRelate(0)"
                                class="cmp-style"/>
                  </div>
                  <!-- 仪表盘  -->
                  <div class="cmp-style" v-if="item.ctype===COMPONENT_TYPE.DASHBOARD">
                    <dashboard :chartData="item" :component-index="item.key"
                               :startStatus="startStatus"
                               class="cmp-style"/>
                  </div>
                  <!-- 标定量 -->
                  <div class="cmp-style" style="background-color: rgba(127,204,232,0.51)"
                       v-if="item.ctype===COMPONENT_TYPE.INPUT">
                    <single-bind :single-bind-index="item.key" :single-bind-item="item"
                                 :startStatus="startStatus"
                                 class="cmp-style"/>
                  </div>
                  <!-- 发送组件 -->
                  <div class="cmp-style" style="background-color: rgba(127,204,232,0.51)"
                       v-if="item.ctype===COMPONENT_TYPE.SEND">
                    <submit-cmp :startStatus="startStatus"
                                :submit-index="item.key"
                                :submit-item="item" class="cmp-style"/>
                  </div>
                  <!-- 单数据显示组件 -->
                  <div class="cmp-style" style="background-color: rgba(127,204,232,0.51)"
                       v-if="item.ctype === COMPONENT_TYPE.OUTPUT">
                    <single-output :component-index="item.key" :item-data="item"></single-output>
                  </div>
                  <!-- 地图组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.MAP">
                    <baidu-map :component-index="item.key" :item-data="item"
                               :distance-to-left="getDistanceToLeft(item)">
                    </baidu-map>
                  </div>
                  <!-- UDS诊断服务组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.UDS">
                    <uds :component-index="item.key" :item-data="item">
                    </uds>
                  </div>
                  <!-- 视频组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.VIDEO">
                    <video-cmp :component-index="item.key" class="cmp-style"></video-cmp>
                  </div>
                  <!-- 自定义帧发送组件 -->
                  <div class="cmp-style" style="background-color: rgba(127,204,232,0.51)"
                       v-if="item.ctype === COMPONENT_TYPE.CUSTOMFRAMES">
                    <custom-frames :component-index="item.key" :startStatus="startStatus"></custom-frames>
                  </div>
                  <!-- 条件判断组件 -->
                  <div class="cmp-style" style="background-color: rgba(127,204,232,0.51)"
                       v-if="item.ctype === COMPONENT_TYPE.CONDITION">
                    <condition :component-index="item.key" :item-data="item"></condition>
                  </div>
                  <!-- 自定义组件 -->
                  <!-- 滑动组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.SLIDER">
                    <boolean :component-index="item.key"></boolean>
<!--                    <slider :component-index="item.key" :item-data="item"></slider>-->
<!--                    <tank :component-index="item.key"></tank>-->
<!--                    <pull-down :component-index="item.key"></pull-down>-->
                  </div>
                  <!-- 显示组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.NUMERICINDICATOR">
                    <numeric-indicator class="cmp-style" :component-index="item.key" :item-data="item"></numeric-indicator>
                  </div>
                  <!-- 控制组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.NUMERICCONTROL">
                    <numeric-control :component-index="item.key" :item-data="item"></numeric-control>
                  </div>
                  <!-- 触发器组件 -->
                  <div class="cmp-style" v-if="item.ctype === COMPONENT_TYPE.TRIGGER">
                    <trigger :component-index="item.key" :item-data="item"></trigger>
                  </div>
                </grid-item>
              </grid-layout>
              <!--插图组件-->
              <div :key="item.key" class="picture" style="width: 200%;height: 100%"
                   v-for="item in picData" v-if="!loading">
                <insert-pic :component-index="item.key" v-if="item.ctype===COMPONENT_TYPE.PIC"></insert-pic>
                <table-switch :chartData="item"
                              :component-index="item.key"
                              :dataSources="item.dataSources"
                              v-if="item.ctype===COMPONENT_TYPE.SWITCHER"></table-switch>
              </div>
            </div>
            <!-- 报告tabs -->
            <report-tabs class="reportTabs" v-show="!getFullscreenStatus"></report-tabs>
          </el-main>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SignalLineChart from '@/components/engineering/SignalLineChart';
import Dashboard from '@/components/engineering/Dashboard';
import SingleBind from '@/components/engineering/SingleBind';
import SubmitCmp from '@/components/engineering/SubmitCmp';
import LeftAside from '@/components/engineering/LeftAside';
import ReportTabs from '@/components/engineering/ReportTabs';
import SingleOutput from '@/components/engineering/SingleOutput';
import TableSwitch from '@/components/engineering/TableSwitch';
import BaiduMap from '@/components/engineering/BaiduMap';
import UDS from '@/components/engineering/UDS';
import InsertPic from '@/components/engineering/InsertPic';
import Video from '@/components/engineering/Video';
import CustomFrames from '@/components/engineering/CustomFrames';
import Condition from '../../components/engineering/Condition';
import NumericControl from '../../components/engineering/NumericControl';
import NumericIndicator from '../../components/engineering/NumericIndicator';
import Trigger from '../../components/engineering/Trigger';
import Slider from '../../components/engineering/Slider';
import Tank from '../../components/engineering/Tank';
import Boolean from '../../components/engineering/Boolean';
import PullDown from '../../components/engineering/PullDown';
import { COMPONENT_TYPE } from '@/common/enums';
import VueGridLayout from 'vue-grid-layout';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'eng-detail-page',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    'signal-cmp': SignalLineChart,
    dashboard: Dashboard,
    'single-bind': SingleBind,
    'submit-cmp': SubmitCmp,
    'left-aside': LeftAside,
    'report-tabs': ReportTabs,
    'single-output': SingleOutput,
    'table-switch': TableSwitch,
    'baidu-map': BaiduMap,
    uds: UDS,
    'insert-pic': InsertPic,
    'video-cmp': Video,
    'custom-frames': CustomFrames,
    'numeric-control': NumericControl,
    'numeric-indicator': NumericIndicator,
    trigger: Trigger,
    slider: Slider,
    tank: Tank,
    boolean: Boolean,
    'pull-down': PullDown,
    condition: Condition,
  },
  data() {
    return {
      // 开始和结束按钮传参：工程id
      projectId: -1,
      // Grid列数
      colNum: 96,
      isClient: false,
      COMPONENT_TYPE,
      // 是否可以拖拽（鼠标点下去进行判断）
      canDrag: false,
      // 控制鼠标样式（是否在可以拖拽的位置）
      isDrag: false,
      // 左侧结构宽度
      leftWidth: 400,
      // 右侧默认宽度
      rightWidth: 250,
      // 路由跳转过来的id
      id: '',
      // 路由跳转过来的工程名字
      name: '',
      websocket: null,
      workOption: [
        { icons: 'ios-pulse-outline', text: '示波器' },
        { icons: 'ios-speedometer-outline', text: '仪表盘' },
        { icons: 'ios-create-outline', text: '标定输入' },
        { icons: 'ios-paper-plane-outline', text: '发送' },
        { icons: 'ios-clipboard-outline', text: '单数据显示' },
        { icons: 'ios-browsers-outline', text: '枚举图' },
        { icons: 'ios-map-outline', text: '地图' },
        { icons: 'ios-image-outline', text: '插图' },
        { icons: 'ios-medkit-outline', text: '诊断服务' },
        // { icons: 'ios-videocam-outline', text: '视频' },
        { icons: 'ios-options-outline', text: '自定义帧' },
        { icons: 'ios-done-all', text: '条件判断' },
      ],
      workOptiontow: [
        { icons: 'el-icon-plus', text: '' },
        { icons: 'el-icon-minus', text: '100%' },
        { icons: 'el-icon-search', text: '' },
      ],
      workOptiothree: [
        { icons: 'ios-archive-outline', text: '保存' },
        { icons: 'ios-undo-outline', text: '撤销' },
        { icons: 'ios-redo-outline', text: '重做' },
      ],
      workOptioform: [
        { icons: 'ios-exit-outline', text: '退出' },
      ],
      numericOption: [
        { icons: 'ios-calculator-outline', text: '数值控制' },
        { icons: 'ios-finger-print', text: '触发器' },
        { icons: 'ios-desktop-outline', text: '数值显示' },
        { icons: 'ios-code', text: '滑动条' },
        { icons: 'ios-beaker-outline', text: '油箱' },
      ],
      booleanOption: [
        { icons: 'ios-checkbox-outline', text: '复选' },
        { icons: 'ios-radio-button-off', text: '圆形LED' },
        { icons: 'ios-square-outline', text: '方形LED' },
        { icons: 'ios-power-outline', text: '电源' },
        { icons: 'ios-alarm-outline', text: '警报' },
      ],
      pullDownOption: [
        { icons: 'ios-paper-outline', text: '下拉' },
      ],
      chartOption: [
        { icons: 'ios-podium-outline', text: '图表' },
      ],
      dashboardOption: [
        { icons: 'ios-plane-outline', text: '里程' },
        { icons: 'ios-beaker-outline', text: '油量' },
        { icons: 'ios-car-outline', text: '车速' },
        { icons: 'ios-flash-outline', text: '电机转速' },
      ],
      picData: [],
      // 图片组件重载触发
      loading: false,
      passwordVisible: false,
      customComponentVisible: false,
      password: '',
      customComponentGroupIndex: '0',
      cptSettingVisible: false,
      exampleFontSize: 15,
      exampleFontColor: '#303133',
    };
  },
  beforeRouteLeave(to, from, next) {
    const self = this;
    // 如果当前面板下的状态是打开的
    if (this.getCurCmpStatus) {
      this.$confirm('离开当前页面会断开数据推送', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => { // 点击确定之后取消面板订阅
        next();
        const projectId = this.projectId;
        self.sendUnsubscription(projectId);
        self.panelSubscriptionClose();
      }).catch(() => {
      });
    } else {
      next();
    }
  },
  computed: {
    ...mapState('Engineering', [
      'displayDetailTabIndex',
      'rightAside',
      'panelList',
      'panelIdList',
      'initPanelDataObj',
      'panelChanged',
      'componentStyleInfoArray',
      'leftStructure',
    ]),
    ...mapGetters('Engineering', ['gridLayoutObj', 'activedPanelData', 'getCurCmpStatus']),
    panelStatus() {
      return this.$store.state.Engineering.curPanelStatus;
    },
    // 工程当前状态
    projectStatus() {
      return this.$store.state.Engineering.curProjectStatus;
    },
    getPanelData_cg() {
      const data = [];
      const pic = [];
      this.$store.state.Engineering.panelDataCcg.forEach((item, index) => {
        if (item.ctype !== COMPONENT_TYPE.PIC && item.ctype !== COMPONENT_TYPE.SWITCHER) {
          item.key = index;
          item.i = index;
          data.push(item);
        } else {
          item.key = index;
          pic.push(item);
          this.loadStyle();
        }
      });
      this.picData = pic;
      return data;
    },
    startStatus: {
      get() {
        if (this.panelList[this.displayDetailTabIndex]) {
          return this.panelList[this.displayDetailTabIndex];
        }
        return { hasStart: -1 };
      },
      set(value) {
        return value;
      },
    },
    curPanelId() {
      return this.$store.state.Engineering.panelId;
    },
    panelTitleStyle() {
      const left = this.leftWidth + 20;
      return `font-size: 16px;font-weight: bold;position:absolute;left:${left}px`;
    },
    // 获取全屏状态，决定是否隐藏头栏
    getFullscreenStatus() {
      return this.$store.getters.getFullscreenStatus;
    },
    // 自定义组件编辑按钮是否显示
    cptsEditVisible() {
      if (this.$store.state.Engineering.selectedCpts.length > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {},
  mounted() {
    const that = this;
    const { params: { id = '', name = '' } = {} } = this.$route;
    that.name = name;
    // 获取工程id
    this.projectId = id;
    const projectId = id;
    // 获取当前工程的所有面板id并设置到数据库中
    this.getPanelIdList({ projectId });
    // 获取面板信息所有面板列表
    // this.getPanelAllList({ projectId: id });
    setTimeout(() => {
      this.getPanelAllList({ projectId: id });
    }, 500);
    this.sendSubscription({ projectId: id });
  },
  methods: {
    ...mapMutations('Engineering', ['setPanelData', 'gridLayoutData', 'setPanelStartStatus', 'setProjectStatus', 'setGrid', 'setEchartResizeKey', 'clearCpt']),
    ...mapActions('Engineering',
      [
        'getPanelAllList', 'savePanelData', 'getPanelIdList',
        'startProject', 'stopProject', 'addComponent',
        'getInitPanelData', 'saveAllCpt', 'StsaveAllCpt',
        'panelSubscription', 'panelSubscriptionClose',
        'sendSubscription', 'sendUnsubscription',
        'bindIniSubscription', 'bindIniUnsubscription',
        'getCptStyle', 'deleteCpts']),
    /**
       * 保存按钮
       * @param payload
       * @returns {Promise<void>}
       */
    async clickTheSaveBtn() {
      const self = this;
      const result = await this.saveAllCpt();
      if (result) {
        this.$message({
          message: '保存成功',
          showClose: true,
          type: 'success',
        });
      } else {
        this.$message({
          message: '保存失败',
          showClose: true,
          type: 'error',
        });
      }
    },
    gridMove(i, newX, newY) {
      this.setGrid({
        type: 'pos', i, x: newX, y: newY,
      });
    },
    moveEvent(i, newX, newY) {
    },
    gridResize(i, newH, newW) {
      this.setGrid({
        type: 'size', i, x: newW, y: newH,
      });
      this.setEchartResizeKey();
    },
    gridResized() {
      this.saveAllCpt();
    },
    // 操作相关（主要用来操作面板里面组件的数据，进行保存/回退和重做）
    operateRelate(index) {
      const { curPanelId } = this;
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (index) {
        case 0:
          this.clickTheSaveBtn({ panelId: curPanelId });
          break;
        case 1:
          break;
        case 2:
          break;
        default:
          break;
      }
    },
    // 原来以面板id为参数的开始函数
    // async startToGetPanelData() {
    //   this.$message.info('面板启动中，请稍候');
    //   const { displayDetailTabIndex, panelList, curPanelId } = this;
    //   let result = true;
    //   if (this.panelChanged) {
    //     result = await (this.saveAllCpt());
    //   }
    //   if (result) {
    //     this.startPanel({ panelId: curPanelId, that: this })
    //       .then((res) => {
    //         /**
    //            * 代表有人触发了该面板上的start按钮需要执行一个监听事件
    //            * @type {boolean}
    //            */
    //         this.isClient = true;
    //         this.$message.success('面板已启动');
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         this.$message({
    //           message: err[1],
    //           type: 'error',
    //         });
    //       });
    //   }
    // },
    async startToGetPanelData() {
      this.$message.info('面板启动中，请稍候');
      const { projectId } = this;
      const panelIdList = this.panelIdList;
      this.getPanelIdList({ projectId });
      let result = true;
      // ideal：当前面板改变，意思是只要有一个面板改变就触发保存
      if (this.panelChanged) {
        // result = await (this.StsaveAllCpt(panelIdList));
        result = await (this.saveAllCpt());
      }
      if (result) {
        this.startProject({ projectId, that: this })
          .then((res) => {
            /**
               * 代表有人触发了该面板上的start按钮需要执行一个监听事件
               * @type {boolean}
               */
            this.isClient = true;
            this.$message.success('面板已启动');
          })
          .catch((err) => {
            console.error(err);
            this.$message({
              message: err[1],
              type: 'error',
            });
          });
      }
    },

    async stopToGetPanelData() {
      const { displayDetailTabIndex, panelIdList, projectId } = this;
      console.log(panelIdList);
      let result = true;
      if (this.panelChanged) {
        // result = await (this.StsaveAllCpt(panelIdList));
        result = await (this.saveAllCpt());
      }
      if (result) {
        this.stopProject({ projectId })
          .then((res) => {
            this.setPanelStartStatus({ displayDetailTabIndex, startStatus: false });
            // this.setProjectStatus({ status: false });
            this.$message({
              showClose: true,
              message: '面板已停止',
              type: 'info',
            });
          }).catch((error) => {
            this.$message({
              showClose: true,
              message: '停止失败',
              type: 'error',
            });
          });
      }
    },
    // 处理组件拖拽
    handleDragComponent(event, item) {
      event.dataTransfer.effectAllowed = 'copyMove';
      event.dataTransfer.setData('componentName', item.text);
    },
    // 处理组件点击
    async handleClickComponent(event, item) {
      const { curPanelId } = this;
      const pos = [0, 0];
      // panelList[displayDetailTabIndex] => 当前的panelID
      const dragComponent = item.text;
      // 逻辑上运行插图任意时刻插入
      if (dragComponent !== '插图' && this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      if (dragComponent) {
        let result;
        switch (dragComponent) {
          case '示波器':
            result = await this.addComponent({ panelId: curPanelId, type: 1, pos });
            break;
          case '仪表盘':
            result = await this.addComponent({ panelId: curPanelId, type: 2, pos });
            break;
          case '标定输入':
            this.passwordVisible = true;
            // result = await this.addComponent({ panelId: curPanelId, type: 3 });
            break;
          case '发送':
            result = await this.addComponent({ panelId: curPanelId, type: 4, pos });
            break;
          case '插图':
            result = await this.addComponent({ panelId: curPanelId, type: 5, pos });
            this.loadStyle();
            break;
          case '枚举图':
            result = await this.addComponent({ panelId: curPanelId, type: 6, pos });
            break;
          case '单数据显示':
            result = await this.addComponent({ panelId: curPanelId, type: 7, pos });
            break;
          case '地图':
            if (this.getPanelData_cg.filter(component => component.ctype === 8).length > 0) {
              this.$message.warning('不允许重复添加地图');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 8, pos });
            }
            break;
          case '诊断服务':
            if (this.getPanelData_cg.filter(component => component.ctype === 9).length > 0) {
              this.$message.warning('不允许重复添加UDS组件');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 9, pos });
            }
            break;
          case '视频':
            if (this.getPanelData_cg.filter(component => component.ctype === 10).length > 0) {
              this.$message.warning('不允许重复添加视频组件');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 10, pos });
            }
            break;
          case '自定义帧':
            if (this.leftStructure.length == 0) {
              this.$message.error('请添加设备！');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 11, pos });
            }
            break;
          case '数值控制':
            result = await this.addComponent({ panelId: curPanelId, type: 15, pos });
            break;
          case '数值显示':
            result = await this.addComponent({ panelId: curPanelId, type: 14, pos });
            break;
          case '滑动条':
            result = await this.addComponent({ panelId: curPanelId, type: 13, pos });
            break;
          case '触发器':
            result = await this.addComponent({ panelId: curPanelId, type: 16, pos });
            break;
          case '条件判断':
            result = await this.addComponent({ panelId: curPanelId, type: 17, pos });
            break;
          default:
            if (result) {
              this.operateRelate(0);
            }
            break;
        }
      }
    },
    // 添加标定输入组件
    add() {
      this.passwordVisible = false;
      if (this.password === '123456') {
        this.addSingleBind();
        this.$message({
          message: '标定输入组件添加成功！',
          type: 'success',
        });
      } else if (this.password === '') {
        this.$message.error('请输入密码以启用标定输入组件！');
      } else {
        this.$message.error('密码错误，请重新输入密码以启用标定输入组件！');
      }
    },
    async addSingleBind() {
      await this.addComponent({ panelId: this.curPanelId, type: 3, pos: [0, 0] });
    },
    // 把组件拖拽到面板中
    async dragTocomponentsContainer(event) {
      // margin 10px
      // x偏移 400 y偏移 170
      // x单位 31 y单位5
      console.log(`x:${event.pageX}y:${event.pageY}`);
      // console.log([parseInt((event.pageX - 410) / 20, 10), parseInt((event.pageY - 180) / 5, 10)]);
      const pos = [parseInt((event.pageX - 410) / 30, 10), parseInt((event.pageY - 180) / 5, 10)];
      const { curPanelId } = this;
      const dragComponent = event.dataTransfer.getData('componentName');
      // 由于插图不需要绑定信号，运行任意时刻插入
      if (dragComponent !== '插图' && this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      if (dragComponent) {
        let result;
        switch (dragComponent) {
          case '示波器':
            result = await this.addComponent({ panelId: curPanelId, type: 1, pos });
            break;
          case '仪表盘':
            result = await this.addComponent({ panelId: curPanelId, type: 2, pos });
            break;
          case '标定输入':
            this.passwordVisible = true;
            // result = await this.addComponent({ panelId: curPanelId, type: 3 });
            break;
          case '发送':
            result = await this.addComponent({ panelId: curPanelId, type: 4, pos });
            break;
          case '插图':
            result = await this.addComponent({ panelId: curPanelId, type: 5, pos });
            this.loadStyle();
            break;
          case '枚举图':
            result = await this.addComponent({ panelId: curPanelId, type: 6, pos });
            break;
          case '单数据显示':
            result = await this.addComponent({ panelId: curPanelId, type: 7, pos });
            break;
          case '地图':
            if (this.getPanelData_cg.filter(item => item.ctype === 8).length > 0) {
              this.$message.warning('不允许重复添加地图');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 8, pos });
            }
            break;
          case '诊断服务':
            result = await this.addComponent({ panelId: curPanelId, type: 9, pos });
            break;
          case '视频':
            if (this.getPanelData_cg.filter(component => component.ctype === 10).length > 0) {
              this.$message.warning('不允许重复添加视频组件');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 10, pos });
            }
            break;
          case '自定义帧':
            if (this.leftStructure.length == 0) {
              this.$message.error('请添加设备！');
            } else {
              result = await this.addComponent({ panelId: curPanelId, type: 11, pos });
            }
            break;
          case '数值控制':
            result = await this.addComponent({ panelId: curPanelId, type: 15, pos });
            break;
          case '数值显示':
            result = await this.addComponent({ panelId: curPanelId, type: 14, pos });
            break;
          case '滑动条':
            result = await this.addComponent({ panelId: curPanelId, type: 13, pos });
            break;
          case '触发器':
            result = await this.addComponent({ panelId: curPanelId, type: 16, pos });
            break;
          default:
            if (result) {
              this.operateRelate(0);
            }
            break;
        }
      }
    },
    // 鼠标移动事件，兼容触控
    containerMousemove(e) {
      // console.log(e);
      const _this = this;
      let touch;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      const { leftWidth, canDrag } = this;
      // 鼠标距离html最左侧距离
      const L = touch.clientX;
      _this.isDrag = L > leftWidth - 3 && L < leftWidth + 5;
      // 左边拖动
      // if (L > leftWidth - 3 && L < leftWidth + 5) {
      _this.leftWidth = canDrag ? L : _this.leftWidth;
    },
    // 鼠标按下事件，兼容触控
    containerMouseDown(e) {
      const _this = this;
      let touch;
      if (e.touches) {
        touch = e.touches[0];
      } else {
        touch = e;
      }
      const { leftWidth } = this;
      const L = touch.clientX;
      _this.canDrag = (L > leftWidth - 3 && L < leftWidth + 5);
    },
    // 鼠标抬起事件，兼容触控
    containerMouseup() {
      this.canDrag = false;
    },
    // 退出工程事件
    exitProject() {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      this.$router.push('/engineering');
    },
    minimize() {
      this.leftWidth = 0;
    },
    loadStyle() {
      this.loading = true;
      setTimeout(() => this.loading = false, 50);
    },
    allowComponentDrop(event) {
      event.preventDefault();
    },
    /**
       * 切换全屏的状态
       */
    switchFullscreen() {
      const status = this.getFullscreenStatus;
      if (!status) {
        this.leftWidth = 0;
      }
      this.$store.commit('setFullscreenStatus', !status);
    },
    // 批量设置自定义组件样式
    async setSelectedCptStyle() {
      const selectedCpts = this.$store.state.Engineering.selectedCpts;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentStyleParams = [];
      for (let i = 0; i < selectedCpts.length; i += 1) {
        const componentStyleParam = {
          componentId: selectedCpts[i],
          wordSize: this.exampleFontSize,
          wordColor: this.exampleFontColor,
        };
        componentStyleParams.push(componentStyleParam);
      }
      await projectDetailAPI.saveCptStyle(projectId, panelId, componentStyleParams)
        .catch((err) => {
          this.$message.error('保存失败！');
        });
      this.clearCpt();
      this.getCptStyle();
    },
    //  批量删除选中组件
    deleteSelectedCpts() {
      const cidList = this.$store.state.Engineering.selectedCpts;
      this.deleteCpts({ cidList });
      // for (let i = 0; i < selectedCpts.length; i += 1) {
      //   const item = selectedCpts[i];
      //   for (let index = 0; index < this.getPanelData_cg.length; index += 1) {
      //     if (item === this.getPanelData_cg[index].cid) {
      //       console.log(item);
      //       setTimeout(() => {
      //         this.selectCpt(item);
      //         this.deleteCpt({ index });
      //       }, 120);
      //       break;
      //     }
      //   }
      // }
    },
    /**
       * 获取当前组件到屏幕最左侧的距离
       * 3000为当前组件区的总宽度
       * 20为当前组件区padding左右间距
       * 3000-20*2=2960
       */
    getDistanceToLeft(item) {
      const curWidth = 2960;
      return ((curWidth / this.colNum) * item.x) + this.leftWidth + 20;
    },
  },
};
</script>

<style lang="scss">
  @import "../../style/mixin";
  @import "../../style/media";

  .eng-detail-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    scrollbar-width: none;
    @include hide-scroll-bar;

    .detailHeader {
      background: linear-gradient(to top, rgba(51, 137, 232, 0.5), rgba(51, 137, 232, 0.75));
      flex-shrink: 0;
      flex-grow: 0;
      padding: 0;
      width: 100%;
      @include max_800 {
        width: 800px !important;
        overflow: auto;
      }

      .detailBread {
        width: 100%;
        height: 100%;
        line-height: 60px;
        padding-left: 30px;

        .el-breadcrumb__inner {
          color: white;
        }

        .el-icon-arrow-right {
          color: white;
        }
      }

      .workOption {
        ul {
          li {
            float: left;
            padding: 10px;
            cursor: pointer;

            i {
              display: block;
              color: #fff;
            }

            i:nth-child(1) {
              font-size: 24px;
              text-align: center;
            }

            .minisize {
              font-size: 12px;
            }

            &.drag-component {
              cursor: pointer;
            }
          }
        }
      }
    }

    .detail-main {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: nowrap;

      .left-aside {
        position: relative;
        border-right: 1px solid #eee;
        background: #fff;
        display: flex;
        flex-direction: column;
        height: 100%;
        @include focus-scroll-bar;

        .structure {
          float: left;
          width: 100%;
          height: 50px;
          line-height: 50px;
          font-weight: bold;
          padding-left: 20px;
          background: #fff;
          font-size: 16px;

          .dropdowm {
            margin-left: 10px;
            margin-top: 5px;
            font-size: 22px;
          }

          .resize {
            float: right !important;
            margin-top: 10px;
            font-size: 22px;
            margin-right: 20px;
          }
        }

        .serchInp {
          width: 60%;
          margin: 10px 0 10px 20px;
          font-size: 14px;

          i {
            font-size: 14px;
          }
        }

        .el-tree {
          background: #fff;
          flex: 1;

          .custom-tree-node {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-right: 20px;

            .custom-label {
              padding-left: 20px;
            }
          }
        }

        .passageway {
          position: absolute;
          width: 100px;
          height: 60px;
          border: 1px solid #999;
          right: 20px;
          top: 120px;

          li {
            width: 100%;
            height: 50%;
            text-align: center;
            line-height: 30px;
            color: #999;
            cursor: pointer;
          }

          li:hover {
            background: #B4B4B4;
          }

          li:nth-child(1) {
            border-bottom: 1px solid #999;
          }

          .el-dialog__body {
            height: 300px;
          }

          .selectBorder {
            width: 100%;
            height: 250px;
            border: 1px solid #eee;
            padding-left: 90px;
            padding-top: 20px;

            .el-cascader-menu {
              height: 150px;
            }
          }
        }
      }

      .components-part-fullscreen {
        padding: 0 !important;
      }

      .components-part {
        display: flex;
        flex-direction: column;
        padding: 0 0 50px 0;

        .panel-title {
          height: 50px;
          flex-shrink: 0;
          flex-grow: 0;
          display: flex;
          width: 1280px;
          @include min_1280 {
            width: 100%;
          }
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          border-bottom: solid 1px #eee;
          padding-left: 20px;
          padding-right: 20px;
          overflow: hidden;
        }

        .data-require-btn {
          position: absolute;
          right: 60px;

        }

        .fullscreen-btn {
          position: absolute;
          right: 20px;
        }

        .components-container {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          overflow: auto;
          justify-content: flex-start;
          padding: 10px;
          border-right: 1px solid #eee;
          width: 3000px;
          @include focus-scroll-bar;

          .hide-border {
            border: 0 !important;
          }

          .cmp-style {
            border: 0 !important;
            width: 100%;
            height: 100%;
            overflow-y: auto;
            @include hide-scroll-bar;
          }

          /*鼠标样式未准备拖拽样式*/
          &.mouseDrag {
            cursor: col-resize;
          }

          .el-row {
            margin-top: 20px;
          }

          .vue-grid-layout {
            .vue-grid-item {
              border: 1px solid #000;
            }
          }

          .illustration-grid {
            width: 100%;
            height: 100%;
            border: 1px solid grey;
          }
        }

        .reportTabs {
          position: absolute;
          bottom: 15px;
          z-index: 0;
          width: 100%;
          background: #ffffff;
          flex-shrink: 0;
          flex-grow: 0;
        }
      }

      .right-aside {
        background-color: #eee;
        display: flex;
        flex-direction: column;

        .title {
          height: 50px;
          line-height: 50px;
          text-align: center;
          background-color: #fff;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/engineering/detail.vue